/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Learn_MoreInputs */

const en_admin_dashboard_learn_more = /** @type {(inputs: Admin_Dashboard_Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Learn more`)
};

const de_admin_dashboard_learn_more = /** @type {(inputs: Admin_Dashboard_Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mehr erfahren`)
};

const es_admin_dashboard_learn_more = /** @type {(inputs: Admin_Dashboard_Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Más información`)
};

const fr_admin_dashboard_learn_more = /** @type {(inputs: Admin_Dashboard_Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lire plus`)
};

const it_admin_dashboard_learn_more = /** @type {(inputs: Admin_Dashboard_Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scopri di più`)
};

const pt_br2_admin_dashboard_learn_more = /** @type {(inputs: Admin_Dashboard_Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saiba mais`)
};

const pl_admin_dashboard_learn_more = /** @type {(inputs: Admin_Dashboard_Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dowiedz się więcej`)
};

const hu_admin_dashboard_learn_more = /** @type {(inputs: Admin_Dashboard_Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Továbbiak`)
};

const ro_admin_dashboard_learn_more = /** @type {(inputs: Admin_Dashboard_Learn_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aflati mai multe`)
};

/**
* | output |
* | --- |
* | "Learn more" |
*
* @param {Admin_Dashboard_Learn_MoreInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_learn_more = /** @type {((inputs?: Admin_Dashboard_Learn_MoreInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Learn_MoreInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_learn_more(inputs)
	if (locale === "de") return de_admin_dashboard_learn_more(inputs)
	if (locale === "es") return es_admin_dashboard_learn_more(inputs)
	if (locale === "fr") return fr_admin_dashboard_learn_more(inputs)
	if (locale === "it") return it_admin_dashboard_learn_more(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_learn_more(inputs)
	if (locale === "pl") return pl_admin_dashboard_learn_more(inputs)
	if (locale === "hu") return hu_admin_dashboard_learn_more(inputs)
	return ro_admin_dashboard_learn_more(inputs)
});
export { admin_dashboard_learn_more as "admin.dashboard.learn_more" }